<!-- Bar search -->
@if (appearance === 'bar' && isMenuPath) {
    @if (!opened) {
        <button mat-icon-button (mousedown)="onSearchButtonMousedown($event)" (click)="open()">
            <mat-icon
                [svgIcon]="'heroicons_outline:magnifying-glass'"
            ></mat-icon>
        </button>
    }
    @if (opened) {
        <div
            class="bg-card absolute inset-0 z-99 flex shrink-0 items-center"
            @slideInTop
            @slideOutTop
        >
            <mat-icon
                class="absolute ms-6 sm:ms-8"
                [svgIcon]="'heroicons_outline:magnifying-glass'"
            ></mat-icon>
            <input
                class="h-full w-full px-16 sm:px-18"
                [formControl]="searchControl"
                [matAutocomplete]="matAutocomplete"
                [placeholder]="'common.placeholders.search' | transloco"
                (keydown)="onKeydown($event)"
                #barSearchInput
            />
            <mat-autocomplete
                class="max-h-128 rounded-b border-t shadow-md sm:px-2"
                [autoSelectActiveOption]="true"
                [disableRipple]="true"
                #matAutocomplete="matAutocomplete"
                (optionSelected)="onOptionSelected($event)"
            >
                @if (resultSets && !resultSets.length) {
                    <mat-option
                        class="text-secondary pointer-events-none bg-transparent px-6 py-0 text-md"
                    >
                        {{ 'common.placeholders.noResults' | transloco }}
                    </mat-option>
                }
                @for (
                    resultSet of resultSets;
                    track trackByFn($index, resultSet)
                ) {
                    <mat-optgroup class="mt-2 flex items-center px-2">
                        <span
                            class="text-secondary text-sm font-semibold tracking-wider"
                            >{{ resultSet.results.length }} {{ 'common.placeholders.resultsFor' | transloco }} "{{ searchValue }}"</span
                        >
                    </mat-optgroup>
                    @for (
                        result of resultSet.results;
                        track trackByFn($index, result)
                    ) {
                        <mat-option
                            class="group relative mb-1 rounded-md px-6 py-1 text-md dark:hover:bg-hover hover:bg-gray-100 min-h-16"
                            (click)="openItem(result)"
                            [value]="result"
                        >
                            <!-- Items -->
                            @if (resultSet.id === 'items') {
                                <ng-container
                                    *ngTemplateOutlet="
                                        itemResult;
                                        context: { $implicit: result }
                                    "
                                ></ng-container>
                            }
                        </mat-option>
                    }
                }
            </mat-autocomplete>
            <button
                class="absolute end-5 top-1/2 -mt-5 h-10 w-10 shrink-0 sm:end-7"
                mat-icon-button
                (mousedown)="onSearchButtonMousedown($event)"
                (click)="close()"
            >
                <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
            </button>
        </div>
    }
}

<!-- Item result template -->
<ng-template #itemResult let-result>
    <div class="flex items-center py-2">
        <div
            class="relative flex h-12 w-12 shrink-0 items-center justify-center overflow-hidden rounded-lg bg-gray-100 dark:bg-zinc-800"
        >
            <!-- Default icon (always present as fallback) -->
            <mat-icon
                class="m-0 text-gray-400 icon-size-6 dark:text-zinc-500"
                [svgIcon]="'heroicons_outline:photo'"
            ></mat-icon>
            
            <!-- Image overlay (shown on top if image exists) -->
            @if (hasValidImage(result)) {
                <picture class="absolute inset-0 h-full w-full">
                    <source 
                        [srcset]="getResultImageSrcSet(result)" 
                        type="image/webp"
                    />
                    <img 
                        [src]="getResultFallbackImageUrl(result)" 
                        [alt]="getResultTitle(result)"
                        class="h-full w-full object-cover rounded-lg"
                        loading="lazy"
                        (error)="onImageError($event)"
                    />
                </picture>
            }
        </div>
        <div class="ms-4 flex-1 min-w-0">
            <div class="font-medium text-gray-900 dark:text-zinc-100 truncate">
                <span [innerHTML]="getResultTitle(result)"></span>
            </div>
            @if (getResultDescription(result)) {
                <div class="text-sm text-gray-500 dark:text-zinc-400 mt-1">
                    {{ getResultDescription(result) }}
                </div>
            }
        </div>

    </div>
</ng-template>
